import { motion } from "framer-motion";
import { ArrowRight, Trophy, Sparkles, HeartHandshake } from "lucide-react";
import { SITE } from "@/config/site";
import { scrollToFormField } from "@/lib/scroll";

const CHIPS = [
  { icon: Trophy, label: "Descuento en tu primer mes" },
  { icon: Sparkles, label: "Prioridad para elegir tamaño" },
  { icon: HeartHandshake, label: "Sin compromiso" },
];

export const OpeningBanner = () => (
  <section data-testid="opening-banner" className="bg-brand-ink text-white py-16 sm:py-20 border-b border-white/10 relative overflow-hidden">
    <div aria-hidden className="absolute -right-20 -top-20 w-72 h-72 rounded-full border-[2.5rem] border-brand-yellow/10" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <span className="inline-flex items-center gap-2 font-mono text-[11px] font-bold tracking-[0.3em] uppercase text-brand-ink bg-brand-yellow rounded-full px-4 py-2">
          <span className="w-1.5 h-1.5 rounded-full bg-brand-ink animate-pulse" />
          Próxima apertura
        </span>
        <h2 className="font-display font-black tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-6 leading-[1.08]">
          Abrimos en <span className="text-brand-yellow">{SITE.openingLabel}</span>.{" "}
          <span className="text-brand-yellow">Prerreserva antes que nadie.</span>
        </h2>
        <p className="mt-4 text-base sm:text-lg text-white/70 leading-relaxed">
          Apúntate ahora con tu prerreserva y consigue prioridad para elegir tamaño
          y descuento en tu primer mes.
        </p>
        <div className="mt-7 flex flex-wrap gap-2.5">
          {CHIPS.map((chip) => (
            <span
              key={chip.label}
              data-testid={`opening-chip-${chip.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="inline-flex items-center gap-2 text-[13px] font-semibold text-white/85 border border-white/20 rounded-full px-4 py-2"
            >
              <chip.icon size={15} className="text-brand-yellow" />
              {chip.label}
            </span>
          ))}
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.2 }}
        className="shrink-0 w-full lg:w-auto lg:min-w-[380px] flex flex-col items-center gap-6"
      >
        <motion.button
          data-testid="opening-banner-cta"
          onClick={() => scrollToFormField()}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-2 bg-brand-yellow text-brand-ink font-display font-extrabold tracking-wide px-8 py-4 rounded-full shadow-[0_10px_35px_rgba(255,230,0,0.3)] hover:bg-brand-yellowhover transition-colors duration-200"
        >
          PRERRESERVAR MI TRASTERO
          <ArrowRight size={18} strokeWidth={2.6} />
        </motion.button>
        <p className="font-mono text-[10px] sm:text-[11px] font-bold tracking-[0.14em] uppercase text-white/45 text-center max-w-xs">
          Sin pago y sin compromiso hasta confirmar apertura y unidad
        </p>
      </motion.div>
    </div>
  </section>
);
